import { MD5 } from 'crypto-js'
import dayjs from 'dayjs'
import { getLocalStorageItem, setLocalStorageItem } from './local-storage.ts'

export function sendErrorMsgToTeams(
  name: string,
  roles: string[],
  description: string
) {
  const teamsWebhookUrl =
    'https://pagcloud.webhook.office.com/webhookb2/817cc8c2-d2eb-4572-b217-ce179cfe3b30@f541de3d-cd73-48a0-aac4-77d090e49ad5/IncomingWebhook/acbc116b678746fea719652b3a57e07a/c1436b59-3325-43a5-a1c3-0c708d521c0d/V231A97v5aX5fszFGo6KEj2HuKSIVr2u-_xaXz4STby481'

  const payload = {
    '@type': 'MessageCard',
    '@context': 'http://schema.org/extensions',
    themeColor: '0076D7',
    summary: `IDEYA has encountered an error`,
    sections: [
      {
        activityTitle: `IDEYA has encountered an error`,
        activitySubtitle: `${window.location.href}`,
        activityImage:
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdjzVPqP7iZef65asE3etO6xu_Ah6yPbhO9g&s',
        facts: [
          {
            name: 'User',
            value: `${name}`,
          },
          {
            name: 'Roles',
            value: `${roles.join(', ')}`,
          },
          {
            name: 'Description',
            value: `${description.replace(/\n/, '</br>')}`,
          },
          {
            name: 'User Agent',
            value: `${window.navigator.userAgent}`,
          },
        ],
        markdown: true,
      },
    ],
  }
  const date = dayjs().format('YYYY-MM-DD')
  const hashedPayload = MD5(JSON.stringify(payload) + date).toString()

  // Ignore these errors (don't send to Teams)
  if (
    description.includes('Insufficient buying power') ||
    description.includes('Failed to validate Ideya Token')
  ) {
    return Promise.resolve({
      msg: 'Ignored errors, not reported to dev team.',
    })
  }

  if (checkErrorsInLocalStorage(hashedPayload)) {
    return Promise.resolve({
      msg: 'Same error occurred, not report to dev team.',
    })
  }

  // we don't need to set the content-type header:
  // https://stackoverflow.com/questions/44334680/cant-post-from-app-to-slack-incoming-webhook
  const reqOpts = {
    method: 'POST',
    body: JSON.stringify(payload),
  }

  return fetch(teamsWebhookUrl, reqOpts)
}

export function checkErrorsInLocalStorage(hashedPayload: string): boolean {
  const key = 'ideya-error'
  const encounteredErrs = getLocalStorageItem(key, [])
  if (encounteredErrs.includes(hashedPayload)) {
    return true
  }

  // if the error is not in the local storage, add it
  encounteredErrs.push(hashedPayload)
  setLocalStorageItem('ideya-error', encounteredErrs)
  return false
}
